import PackageAdditionalServiceEnum from '~/enums/PackageAdditionalServiceEnum'
import type { PackageInterface } from '~/types/shipzeePro/packagesTypes'

export default function shipmentFindService(shipment: PackageInterface, serviceId: PackageAdditionalServiceEnum) {
  return shipment.additional_services.find((service) => service.service_id === serviceId)
}
